export default __webpack_public_path__ + "static/media/hbs-cbb-1.6f3d985f.png";